<template>
    <div>
        <myHeader></myHeader>
        <aboutNav></aboutNav>
        <div class="progress_wrap">
            <div class="progress">
                <div class="progress_left">
                    <img src="../../../static/images/progress_left.png" alt="">
                </div>
                <div class="progress_right">
                    <el-steps direction="vertical">
                        <el-step v-for="(item,index) in HistoryList" :key="index" :title="item.time_name" :description="item.content"></el-step>
                    </el-steps>
                </div>
            </div>
        </div>
        <myFooter></myFooter>
    </div>
</template>

<script>
import myHeader from '../../components/header.vue'
import MyFooter from '../../components/footer.vue'
import aboutNav from '../../components/about_nav.vue'
export default {
    name: 'about_progress',
    components: {MyFooter, myHeader,aboutNav},
    data () {
        return {
            HistoryList:[]
        }
    },
    created () {
        this.pageData();
    },
    methods: {
        pageData () {
            this.$api.devHistoryList().then(res => {
                console.log(res)
                this.HistoryList = res.data;
            });
        },
    }
}
</script>

<style scoped>
.progress_wrap{width:100%;height:auto;min-height:200px;float:left;padding:50px 0 60px;}
.progress{width:1200px;height:900px;display:block;position:relative;left:50%;margin-left:-600px;float:left;}
.progress_left{width:520px;height:900px;display:inline-block;float:left;}
.progress_left img{width:100%;height:auto;display:block;}
.progress_right{width:680px;height:900px;display:inline-block;float:left;padding-left:30px;overflow:hidden;overflow-y:scroll;padding-top:10px;padding-right:20px;}
/deep/ .progress_right .el-step__icon-inner{display:none;}
/deep/ .progress_right .el-step__icon.is-text{width:12px;height:12px;background:#0a64ba;border-color:#0a64ba;margin-left:6px;top:-6px;}
/deep/ .progress_right .el-step__line{background-color:#0a64ba;}
/deep/ .progress_right .el-step.is-vertical .el-step__title{color:#0a64ba;margin-top:-8px;font-size:16px;font-weight:bold;}
/deep/ .progress_right .el-step__description{margin-bottom:20px;background: #f0f0f0;padding:15px;color:#333;}
@media (min-width:992px) and (max-width:1200px){
    .progress_wrap{min-height:200px;padding:40px 0 50px;}
    .progress{width:1000px;height:700px;margin-left:-500px;}
    .progress_left{width:400px;height:700px;}
    .progress_right{width:600px;height:700px;padding-left:25px;padding-top:10px;padding-right:20px;}
    /deep/ .progress_right .el-step.is-vertical{flex-basis:15% !important;}
    /deep/ .progress_right .el-step__icon.is-text{width:12px;height:12px;margin-left:6px;top:-6px;}
    /deep/ .progress_right .el-step.is-vertical .el-step__title{color:#0a64ba;margin-top:-8px;font-size:15px;}
    /deep/ .progress_right .el-step__description{margin-bottom:0;padding:10px;}
}
@media (min-width:768px) and (max-width:991px){
    .progress_wrap{min-height:200px;padding:30px 0 40px;}
    .progress{width:750px;min-height:200px;height:auto;margin-left:-375px;}
    .progress_left{display:none;}
    .progress_right{width:100%;height:700px;padding-left:0;padding-top:10px;padding-right:20px;}
    /deep/ .progress_right .el-step.is-vertical{flex-basis:15% !important;}
    /deep/ .progress_right .el-step__icon.is-text{width:12px;height:12px;margin-left:6px;top:-6px;}
    /deep/ .progress_right .el-step.is-vertical .el-step__title{color:#0a64ba;margin-top:-8px;font-size:15px;}
    /deep/ .progress_right .el-step__description{margin-bottom:0;padding:10px;}
}
@media (max-width:767px){
    .progress_wrap{min-height:200px;padding:20px 15px 30px;}
    .progress{width:100%;min-height:200px;height:auto;margin-left:0;left:0;}
    .progress_left{display:none;}
    .progress_right{width:100%;height:700px;padding-left:0;padding-top:10px;padding-right:10px;}
    /deep/ .progress_right .el-step.is-vertical{flex-basis:15% !important;}
    /deep/ .progress_right .el-step__icon.is-text{width:12px;height:12px;margin-left:6px;top:-6px;}
    /deep/ .progress_right .el-step.is-vertical .el-step__title{color:#0a64ba;margin-top:-8px;font-size:15px;}
    /deep/ .progress_right .el-step__description{margin-bottom:0;padding:10px;}
}
</style>



// WEBPACK FOOTER //
// src/pages/about/about_progress.vue